import { render, staticRenderFns } from "./SubscriptionForm.vue?vue&type=template&id=03952c63&scoped=true&"
import script from "./SubscriptionForm.vue?vue&type=script&lang=js&"
export * from "./SubscriptionForm.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionForm.vue?vue&type=style&index=0&id=03952c63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03952c63",
  null
  
)

export default component.exports